/* istanbul ignore file */
import { array as codecArray, boolean as codecBoolean, number as codecNumber, string as codecString, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { AutoTestFixture } from './AutoTestFixture';
import { AutoTestGlobalSetupScript } from './AutoTestGlobalSetupScript';
import { AutoTestRun } from './AutoTestRun';
import { AutoTestSet } from './AutoTestSet';
const AutoTestParser = /* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.object([
    ['id', codecNumber],
    ['fixtures', /* #__PURE__ */ codecArray(AutoTestFixture)],
    [
        'globalSetup',
        /* #__PURE__ */ codecArray(AutoTestGlobalSetupScript),
        'global_setup',
    ],
    ['setupScript', codecString, 'setup_script'],
    ['finalizeScript', codecString, 'finalize_script'],
    [
        'gradeCalculation',
        /* #__PURE__ */ parsers.maybeNull(/* #__PURE__ */ parsers.exactly('full', 'partial')),
        'grade_calculation',
    ],
    ['sets', /* #__PURE__ */ codecArray(AutoTestSet)],
    ['assignmentId', codecNumber, 'assignment_id'],
    ['runs', /* #__PURE__ */ codecArray(AutoTestRun)],
    [
        'resultsAlwaysVisible',
        /* #__PURE__ */ parsers.maybeNull(codecBoolean),
        'results_always_visible',
    ],
    [
        'preferTeacherRevision',
        /* #__PURE__ */ parsers.maybeNull(codecBoolean),
        'prefer_teacher_revision',
    ],
    ['enableCaching', codecBoolean, 'enable_caching'],
]));
export class AutoTest extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AutoTestParser.decode(input).map(res => new AutoTest(res));
    }
    static unsafeDecode(input) {
        return AutoTest.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutoTestParser.encode(data);
    }
    static schema() {
        return AutoTestParser.schema();
    }
}
